import { LayerManager } from './layerManager.js'
import { MapEventHandler } from './eventHandler.js'

export const SINGAPORE_CONFIG = {
  center: [1.3521, 103.8198],
  zoom: 12,
  minZoom: 10,
  maxZoom: 18,
  maxBounds: [
    [1.15, 103.6],
    [1.5, 104.1]
  ]
}

export class MapEngine {
  constructor(containerId) {
    this.map = null
    this.containerId = containerId
    this.layerManager = new LayerManager()
    this.eventHandler = null
    this.onPointSelected = null
    this.onMapClick = null
  }

  init() {
    this.map = L.map(this.containerId, {
      center: SINGAPORE_CONFIG.center,
      zoom: SINGAPORE_CONFIG.zoom,
      minZoom: SINGAPORE_CONFIG.minZoom,
      maxZoom: SINGAPORE_CONFIG.maxZoom,
      maxBounds: SINGAPORE_CONFIG.maxBounds,
      zoomControl: false,
      attributionControl: true
    })

    this._addBaseLayer()
    this.layerManager.init(this.map)

    this.eventHandler = new MapEventHandler(this)
    this.eventHandler.bindEvents()

    return this
  }

  _addBaseLayer() {
    L.tileLayer(
      'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20
      }
    ).addTo(this.map)
  }

  setPointSelectedCallback(callback) {
    this.onPointSelected = callback
  }

  setMapClickCallback(callback) {
    this.onMapClick = callback
  }

  addMarker(latLng, options = {}) {
    const marker = L.marker(latLng, {
      icon: this._createSelectedIcon(),
      ...options
    }).addTo(this.map)
    return marker
  }

  removeMarker(marker) {
    if (marker) {
      this.map.removeLayer(marker)
    }
  }

  flyTo(latLng, zoom = 15) {
    this.map.flyTo(latLng, zoom, {
      duration: 1.5,
      easeLinearity: 0.25
    })
  }

  resetView() {
    this.map.flyTo(SINGAPORE_CONFIG.center, SINGAPORE_CONFIG.zoom, {
      duration: 1
    })
  }

  getViewState() {
    return {
      center: this.map.getCenter(),
      zoom: this.map.getZoom(),
      bounds: this.map.getBounds()
    }
  }

  _createSelectedIcon() {
    return L.divIcon({
      className: 'selected-point-marker',
      html: '<div class="marker-pulse"></div>',
      iconSize: [20, 20],
      iconAnchor: [10, 10]
    })
  }

  destroy() {
    if (this.eventHandler) {
      this.eventHandler.unbindEvents()
    }
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }
}
